import { useTranslation } from 'react-i18next'

import { useFetchAllMyOrders } from '@entities/Order/hook/allMyOrders.gql'

import OnlineOrdersList from '@widgets/online-orders-list/ui/OnlineOrdersList'

import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function OnlineOrdersPage () {
  const { t: p } = useTranslation('personal')

  const { orders, hasMore, fetchNextPage, refetch } = useFetchAllMyOrders()

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <h2 className={styles.root__title}>{p('nav.online-orders')}</h2>
      </Wrapper>
      <OnlineOrdersList
        orders={orders}
        hasMore={hasMore}
        fetchNextPage={fetchNextPage}
        refetch={refetch}
      />
    </div>
  )
}
